import { render } from "./CardAmounts.vue?vue&type=template&id=31399848"
import script from "./CardAmounts.vue?vue&type=script&lang=js"
export * from "./CardAmounts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__